import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=33fe830c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=33fe830c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe830c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33fe830c')) {
      api.createRecord('33fe830c', component.options)
    } else {
      api.reload('33fe830c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=33fe830c&scoped=true&", function () {
      api.rerender('33fe830c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yK2fSSWlyC8y/JS/comp/GuestBox.vue"
export default component.exports